import { render } from "./theme.vue?vue&type=template&id=51b531ab"
import script from "./theme.vue?vue&type=script&lang=js"
export * from "./theme.vue?vue&type=script&lang=js"

import "./theme.vue?vue&type=style&index=0&id=51b531ab&lang=css"
script.render = render

export default script